var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "Alarm clock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ringRed",
    x1: 24,
    y1: 26,
    x2: 105,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ef4d43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c93435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bellYellow",
    x1: 26,
    y1: 13,
    x2: 103,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ffc433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaa51d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "faceWhite",
    cx: "48%",
    cy: "38%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fffdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1eee6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "clockShadow",
    x: "-22%",
    y: "-20%",
    width: "144%",
    height: "152%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 4,
    floodColor: "#000000",
    floodOpacity: 0.24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#clockShadow)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 20 Q64 9 79 20",
    fill: "none",
    stroke: "#858b93",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 42 A25 28 0 0 1 67 42 Z",
    fill: "url(#bellYellow)",
    stroke: "#d89818",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 42 A25 28 0 0 1 111 42 Z",
    fill: "url(#bellYellow)",
    stroke: "#d89818",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 67,
    r: 47,
    fill: "url(#ringRed)",
    stroke: "#b82d31",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 67,
    r: 37,
    fill: "url(#faceWhite)",
    stroke: "#f06a58",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 67 V43",
    stroke: "#20242b",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 67 L82 78",
    stroke: "#20242b",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 67,
    r: 5,
    fill: "#20242b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 31v5M64 98v5M29 67h5M94 67h5",
    stroke: "#d94a42",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 111 L35 121",
    stroke: "#858b93",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 111 L93 121",
    stroke: "#858b93",
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClock);
export default __webpack_public_path__ + "static/media/alarm-clock.b525d318649bf0fce7d032c234e0c758.svg";
export { ForwardRef as ReactComponent };